var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"timain"},[_vm._v("4-0-4")]),_c('div',{staticClass:"botitle"},[_vm._v("#/ 当前页面开发中...")]),_c('div',{staticClass:"back-home"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }